import React, { useEffect, useState } from "react";
import "../styles-quality-control/qa_style.css";
import "../styles-quality-control/styles.css";
import { Container, Grid, TextField, Typography, Stack } from "@mui/material";
import Rework from "../Rework/rework";
import ModelName from "../modelName/modelName";
import GpQualityInspectionChecklist from "./GpQualityInspectionChecklist";
import CaptureChassisNo from "../ChassisNoFromCamera/ChassisNoFromCamera";
import { useLocation } from "react-router-dom";
import { useChassis } from "../ChassisNoProvider/ChassisProvider";
import DeleteChecklistButton from "../ClearDataComponent/ClearChecklist";
import DeleteReworkButton from "../ClearDataComponent/ClearRework";

const GpQualityInspection = () => {
  const [tab, setTab] = useState<number>(1);
  const { chassisNo, setChassisNo, canAutoSetChassisNo } = useChassis();
  const [localChassisNo, setLocalChassisNo] = useState<string>(chassisNo || "");
  const [debouncedChassisNo, setDebouncedChassisNo] = useState<string>("");
  const [model, setModel] = useState<string>("");
  const [checkedBy, setLocalCheckedBy] = useState<string>("");
  const location = useLocation();
  const [refreshKey, setRefreshKey] = useState<number>(0);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const queryChassisNo = params.get("chassisNo");
    if (queryChassisNo && canAutoSetChassisNo) {
      setChassisNo(queryChassisNo);
      setLocalChassisNo(queryChassisNo);
    } else if (!canAutoSetChassisNo) {
      setChassisNo("");
      setLocalChassisNo("");
    }
  }, [location.search, setChassisNo, canAutoSetChassisNo]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedChassisNo(localChassisNo);
    }, 2000);

    return () => clearTimeout(timer);
  }, [localChassisNo]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLocalChassisNo(e.target.value);
    if (canAutoSetChassisNo) {
      setChassisNo(e.target.value);
    }
  };

  const handleUploadComplete = (data: { chassisNo: string }) => {
    setLocalChassisNo(data.chassisNo);
    if (canAutoSetChassisNo) {
      setChassisNo(data.chassisNo);
    }
  };

  const handleClearComplete = () => {
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <>
      <nav className="d-flex justify-content-center align-items-center my-4">
        <div className="tab-container d-flex">
          <div className="selector"></div>
          <button
            className={`m-0 d-flex align-items-center gap-2 flex-row-reverse ${
              tab === 1 ? "active" : ""
            }`}
            onClick={() => setTab(1)}
          >
            Checklist
          </button>
          <button
            className={`m-0 ${tab === 2 ? "active" : ""}`}
            onClick={() => setTab(2)}
          >
            Rework
          </button>
        </div>
      </nav>

      <Container sx={{ mt: 2, mb: 3 }}>
        <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
          <Typography variant="h4">
            {tab === 1
              ? "QUALITY CONTROL INSPECTION Checklist"
              : "QUALITY CONTROL INSPECTION Rework"}
          </Typography>
          {tab === 1 && (
            <DeleteChecklistButton
              chassisNo={localChassisNo}
              rework_type="gp-quality-inspection"
              onClearComplete={handleClearComplete}
            />
          )}
          {tab === 2 && (
            <DeleteReworkButton
              chassisNo={localChassisNo}
              stationName="gp-quality-inspection"
              onClearComplete={handleClearComplete}
            />
          )}
        </Stack>

        <Grid container spacing={1} alignItems="center" sx={{ mb: 2 }}>
          <Grid
            item
            md={3}
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
          >
            {tab === 1 && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <CaptureChassisNo onUploadComplete={handleUploadComplete} />
              </div>
            )}

            <TextField
              label="Chassis No"
              variant="filled"
              size="small"
              value={localChassisNo}
              onChange={handleInputChange}
              InputProps={{
                readOnly: tab === 2,
                disabled: tab === 2,
              }}
              sx={{
                "& .MuiInputLabel-root": {
                  fontWeight: "bold",
                  color: "#1976d2 !important",
                },
                "& .MuiInputBase-input": {
                  color: "#1976d2 !important",
                  opacity: "1 !important",
                  "&[disabled]": {
                    color: "rgba(25, 118, 210, 1) !important",
                  },
                  fontSize: "20px",
                },
                flexGrow: 1,
                minWidth: "120px",
              }}
            />
          </Grid>

          <Grid item md={9} sx={{ display: "flex", alignItems: "center" }}>
            <ModelName model={model} />
          </Grid>
        </Grid>

        {tab === 1 && (
          <GpQualityInspectionChecklist
            key={refreshKey}
            chassisNo={debouncedChassisNo}
            setModel={setModel}
            model={model}
            setCheckedBy={setLocalCheckedBy}
            isDisabled={canAutoSetChassisNo}
          />
        )}

        {tab === 2 && (
          <Rework
            key={refreshKey}
            chassisNo={debouncedChassisNo}
            model={model}
            reworkType="gp-quality-inspection"
            checkedBy={checkedBy}
          />
        )}
      </Container>
    </>
  );
};

export default GpQualityInspection;
